// extracted by mini-css-extract-plugin
export default {"root":"D4WgTT","CirclesMenuButtonSkin":"vEGLrK","circlesMenuButtonSkin":"vEGLrK","linkElement":"fGH7EU","bg":"tL9eKO"};